/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useTagPlan } from 'features/tagPlan/business/useTagPlan';
import { useRouter } from 'next/router';
import React, { ComponentPropsWithRef, FC, useEffect } from 'react';
import { AdvertService } from '@adverts/business/Advert.service';
import { ADVERT_FORMAT_ID } from '@adverts/business/Adverts.contants';
import classnames from 'classnames';
import { ATLevel2 } from 'features/tagPlan/business/TagPlan.types';
import styles from './GenericAd.module.scss';

export type AdProps = Omit<ComponentPropsWithRef<'div'>, 'id'> & {
  formatId: ADVERT_FORMAT_ID;
};

const GenericAd: FC<AdProps> = ({ formatId, className, ...rest }) => {
  const rootClass = classnames(
    styles['generic-ad'],
    formatId === ADVERT_FORMAT_ID.Block ? styles['ad-block'] : '',
    ADVERT_FORMAT_ID.NativeAd || formatId === ADVERT_FORMAT_ID.NativeAdBis ? styles['ad-native'] : '',
    formatId === ADVERT_FORMAT_ID.SmallNative ? styles['ad-native-small'] : '',
    formatId === ADVERT_FORMAT_ID.InlineVideo ? styles['ad-video'] : '',
    {
      'flex justify-center': formatId === ADVERT_FORMAT_ID.Block,
    },
    className
  );

  const { tagClick } = useTagPlan();

  function handleTagClick() {
    tagClick({
      level2: ATLevel2.Ads,
      tagPageNameI18nArray: [
        { code: 'Native-ads', notI18n: true },
        { code: String(formatId), notI18n: true },
      ],
    });
  }

  const router = useRouter();

  useEffect(() => AdvertService.render(formatId), [formatId, router]);

  return process.env.NEXT_STATIC_ADS_STATUS === 'disabled' ? null : (
    <div className={rootClass} id={`sas_${formatId}`} onClick={handleTagClick} {...rest} />
  );
};

export { GenericAd };
